<script lang="ts" setup>
import { useDefaultStore } from "@/store";
import { useExpenseTemp } from "@/store/expensesTemp";
import { useToastStore } from "@/store/toast";
import { parseErrors } from "@/assets/js/parseErrors";
import api from "@/api";

const emit = defineEmits(["success", "return"]);
const props = defineProps<{ data: any }>();
const store = useDefaultStore();
const expenseTempStore = useExpenseTemp();
const toast = useToastStore();
const loading = ref(false);

const amount = ref(null);
const receipt = ref(null);
// const cutoffMessage = ref("");

const monet = computed(() => {
	const iStatus = store.initialStatus;
	return iStatus?.monetary_symbol;
});

const renderAsterisk = computed(() => {
	if (!props.data) return "";
	if (
		props.data.expenseType?.code &&
		props.data.status === store.expenseStatus.PENDING
	)
		return "*";
	return "";
});

const allDataItems = computed(() => {
	const arr = [];
	if (!props.data) return arr;
	for (const key of Object.keys(props.data)) {
		if (props.data[key] == null || key == "type" || key == "amount") continue;
		const item: any = {
			title: formatKeyForDisplay(key),
			value: getValueForDisplay(props.data[key], key),
		};
		if (key == "file") {
			const reader = new FileReader();
			reader.addEventListener("load", (e) => {
				// set key i will be using to display the image
				item.file = e.target.result;
				receipt.value = item;
			});
			// read the blob as data url
			console.log("props.data[key].data", props.data[key]);
			reader.readAsDataURL(props.data[key].data ?? props.data[key].file);
			// do not push the item into array so we can display it seperately
			continue;
		}
		arr.push(item);
	}
	return arr;
});

function formatKeyForServer(key) {
	const keyMapper = {
		// experimental
		amount: "usp_value",
		vehicleType: "upt_id",
		reason: "upt_id",
		type: "upt_id",

		client: "cli_id",
		location: "loc_id", // ward
		category: "cat_id", // grade
		engineType: "engine_size",
		band: "hours_range",
		distance: "mileage",
		file: "file",
		travelFrom: "usp_locationfrom",
		travelTo: "usp_locationto",
		locationOfSubsistence: "usp_locationfrom",
		description: "usp_description",
	};
	return keyMapper[key];
}
function formatValForServer(val) {
	if (typeof val == "object" && (val.from || val.to)) return val;
	if (typeof val == "object" && val.data) return val;
	if (typeof val == "object") return val.id;
	return val;
}
function formatKeyForDisplay(key) {
	const keyMapper = {
		client: "Client",
		location: "Ward", // ward
		category: "Grade", // grade
		vehicleType: "Vehicle Type",
		engineType: "Engine Type",
		time: "Time",
		date: "Date",
		startDate: "Start Date",
		endDate: "End Date",
		startTime: "Start Time",
		endTime: "End Time",
		distance: "Distance",
		travelFrom: "Travel From",
		travelTo: "Travel To",
		locationOfSubsistence: "Location of Subsistence",
		file: "Receipt",
		band: "Band",
		reason: "Reason",
		note: "Note",
		description: "Description",
	};
	return keyMapper[key];
}
function getValueForDisplay(item, key) {
	if (item instanceof File) {
		return item.name;
	}
	if (typeof item === "object") {
		return item.value || item.name;
	}
	if (key === "distance") {
		return item + " km";
	}

	return item;
}
async function init() {
	loading.value = true;
	try {
		const data = formatData();

		// if is receipt, get amount from user input instead from server
		if (data instanceof FormData) {
			amount.value = data.get("usp_value");
		} else {
			// else fetch from server
			const res = await api.previewExpense(data);
			amount.value = Math.round(res.data.data.value * 100) / 100;
		}
		// if (expenseTempStore.cutoffMessage !== "") {
		// 	cutoffMessage.value = expenseTempStore.cutoffMessage;
		// }
	} catch (error) {
		handleError(error);
		emit("return");
	} finally {
		loading.value = false;
	}
}

function handleError(err: any) {
	const errors = parseErrors(err);
	if (Array.isArray(errors) && errors.length > 0) {
		errors.map((e) => {
			toast.openToastError(e);
		});
	} else if (errors) {
		toast.openToastError(errors);
	}
}
function formatData() {
	let data = {};
	console.log("Noform data:", props.data);
	if (!props.data) {
		emit("return");
		return;
	}
	for (const key of Object.keys(props.data)) {
		const val = props.data[key];
		if (val === null || formatKeyForServer(key) === undefined) continue;
		data[formatKeyForServer(key)] = formatValForServer(val);
	}

	if (props.data.startDate) {
		data["usp_start"] = props.data.startDate;
	}
	if (props.data.date) {
		data["usp_start"] = props.data.date;
	}
	if (props.data.endDate) {
		data["usp_end"] = props.data.endDate;
	}
	if (props.data.client) {
		data["cli_id"] = props.data.client.id;
	}
	if (props.data.location) {
		data["loc_id"] = props.data.location.id;
	}
	if (props.data.category) {
		data["cat_id"] = props.data.category.id;
	}

	if (props.data.file) {
		console.log("FORMDATA");
		const fd = new FormData();
		for (const key of Object.keys(data)) {
			if (key === "file") {
				fd.append(key, props.data[key].file, props.data[key].name);
			} else fd.append(key, data[key]);
		}
		// for (const pair of fd.entries()) {
		// 	// console.log(`${pair[0]}, ${pair[1]}`);
		// }
		data = fd;
	}
	return data;
}
const showConfirmMsg = ref(false);
async function submit() {
	// let submitRequest = async () => {
	loading.value = true;
	try {
		const data = formatData();
		await api.submitExpense(data);
		toast.openToastSuccess("Expense created successfully");
		// navigate("/expenses/");
		emit("success");
	} catch (error) {
		handleError(error);
	} finally {
		loading.value = false;
	}
	// };

	// let callDialog = () => {
	// 	this.$f7.dialog.confirm(
	// 		`Are you sure you want to submit ${this.monet + this.amount} as your new expense?`,
	// 		"Expense:",
	// 		submitRequest,
	// 		cancel,
	// 	);
	// };

	// callDialog();
}
onMounted(() => {
	init();
});
</script>

<template>
	<div class="page has-button">
		<div class="page-content">
			<div class="screen-title title title-color">Expense Claim Summary</div>
			<div
				v-if="loading"
				class="loading-wrapper"
			>
				<img src="@/assets/image/loader.svg" />
			</div>
			<div v-else>
				<div class="preview">
					<div class="top">
						<div class="monet">{{ monet }}</div>
						<div class="amount">{{ amount }} {{ renderAsterisk }}</div>
					</div>
					<div class="bottom">Amount Preview</div>
				</div>

				<div
					v-if="renderAsterisk"
					class="tooltipy title-color"
				>
					* Please note that the amount displayed above is a provisional
					calculation which may update upon approval.
				</div>
				<div
					v-if="expenseTempStore.cutoffMessage !== ''"
					class="tooltipy title-color"
				>
					* {{ expenseTempStore.cutoffMessage }}
				</div>

				<div class="content">
					<div
						v-for="(item, index) in allDataItems"
						:key="index"
						class="group"
					>
						<label class="label">{{ item.title }}</label>
						<div class="value">
							{{ item.value }}
						</div>
					</div>
				</div>

				<receiptRender
					v-if="receipt"
					:receipt="receipt"
				/>
			</div>
			<div class="wrap-btn">
				<div class="msg">
					<span
						v-if="showConfirmMsg"
						class="error-msg"
					>
						Are you sure you want to submit {{ monet + amount }} as your new
						expense?
					</span>
				</div>
				<div class="buttons-centered">
					<button
						class="button alt"
						@click.prevent="
							showConfirmMsg ? (showConfirmMsg = false) : emit('return')
						"
					>
						{{ showConfirmMsg ? "Cancel" : "Return" }}
					</button>
					<button
						v-if="!showConfirmMsg"
						class="button"
						@click="showConfirmMsg = true"
					>
						Create
					</button>
					<button
						v-if="showConfirmMsg"
						class="button"
						:disabled="loading"
						@click="submit"
					>
						Yes create
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
$color-light-gray: #dde6eb;
$color-fa: #7c91ae;
$background-color-price: #e7edf4cc;
.page-content {
	display: flex;
	flex-direction: column;
	min-height: 100%;
}

.screen-title {
	// color: var(--color-primary);

	font-size: 18px;
	font-weight: 900;
	width: 100%;
}
.loading-wrapper {
	width: 100%;
	img {
		margin: auto;
	}
}
.tooltipy {
	display: flex;
	justify-content: flex-start;
	// align-items: center;
	width: 100%;
	margin: 10px auto;
	font-style: italic;
	line-height: 17px;
	.status {
		font-size: 15px;
		font-weight: 900;
		margin-right: 15px;
	}
}
.preview {
	background-color: rgba(231, 237, 244, 0.8);
	width: 100%;
	height: 120px;
	margin: 15px auto 18px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.top {
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--home-title-color);
		font-weight: 900;
		.monet {
			font-size: 25px;
			transform: translateY(5px);
			margin-right: 5px;
		}
		.amount {
			font-size: 55px;
		}
	}
	.bottom {
		position: relative;
		top: -10px;
		opacity: 0.6;
		font-weight: 900;
	}
}

.group {
	// display: flex;
	align-items: center;
	justify-content: space-between;
	// background-color: $color-light-gray;
	border-bottom: 1px solid $color-light-gray;
	margin-bottom: 5px;
	padding: 5px 10px;
	border-radius: 5px;

	label {
		color: $color-fa;
		text-align: right;
		// width: 40px;
		margin-top: 5px;
		margin-right: 10px;
	}
}
.wrap-btn {
	height: 130px;
	display: flex;
	flex-direction: column;
	margin-top: auto;
}
.buttons-centered {
	padding-bottom: 30px;
	height: 60px !important;
}
.msg {
	text-align: center;
	margin-top: 30px;
}
.error-msg {
	display: inline-block;
	// margin-top: 30px;
	color: $error-color !important;
}
</style>
